@if (isLoading()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
} @else {
  @for (table of tables(); track table.cropField.id) {
    <div class="observation-table">
      <div class="table-title spacing--margin-half-bottom">
        <b>{{ 'cropField' | translate }}</b> {{ table.cropField.name }}
      </div>
      @if (table.rows.length === 0) {
        <p class="no-data">{{ 'downyMildew.observationHistory.noData' | translate }}</p>
      } @else {
        <table mat-table [dataSource]="table.rows" class="table-wrapper" data-test="observation-history-table">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{ 'downyMildew.observationHistory.date' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.observationDate | date: 'shortDate' : 'UTC' : locale }}</td>
          </ng-container>

          <ng-container matColumnDef="severity">
            <th mat-header-cell *matHeaderCellDef>{{ 'downyMildew.observationHistory.severity' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              {{ 'downyMildew.observation.severityLevels.' + row.severity | translate }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button
                mat-icon-button
                type="button"
                (click)="onRemoveRegistration(row)"
                [attr.aria-label]="'downyMildew.observationHistory.remove' | translate"
                data-test="observation-remove"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
      }
    </div>
  }
}
